import { SET_SUCURSAL } from "../constanst";

const initialState = {
    sucursal:null,
}

export default function(state = initialState, action) {
    switch (action.type) {
        case  SET_SUCURSAL:
            return{
                ...state,
                sucursal:action.payload
            }
        default:
            return state;
    }
}